let interacted = false;

$(document).ready(function() {
  document.addEventListener('mousemove', () => interacted = true );
  document.addEventListener('keypress', () => interacted = true );
	// Tabs
	$('.ysw-feedback-form-container .swatch-tab-container .desktop-swatch-tabs ul.tabs li').click(function() {
		var tab_id = $(this).data('tab');
      $('.ysw-feedback-form-container .swatch-tab-container[data-tab="' + tab_id + '"]').addClass('show');
		$('html, body').animate({
			scrollTop: $('.ysw-feedback-form-container .swatch-tab-container[data-tab="' + tab_id + '"]').offset().top - 70
		}, 750);
	});

	// Scroll to send button
	$('.ysw-feedback-form-container .swatch-tab-container .bottom-tab-actions .link a.scroll-to-send-btn').click(function() {
		var tab_id = $(this).data('tab');
		$('html, body').animate({
			scrollTop: $('.ysw-feedback-form-container .send-button-container').offset().top - 70
		}, 750);
	});
  
  var tab_ids = [];
  var pageURL = window.location.href;
  // If hash is present
  if(String(pageURL).indexOf('#') > -1) {
    var splitURL = pageURL.split('#');
    var urlFragment = splitURL[1];
    urlFragment = urlFragment.split('&');
    urlFragment.forEach(function(swatch_type) {
	
      if(swatch_type == 'kfi-fabric-swatch') {
        tab_ids.push('1');
      }else if(swatch_type == 'leather-swatch-main') {
        tab_ids.push('4');
      } else if(swatch_type == 'leather-swatch') {
       	tab_ids.push('5');
      } else if(swatch_type == 'fabric-swatch-main') {
        tab_ids.push('3');
      } else if(swatch_type == 'fabric-swatch') {
		tab_ids.push('2');
      }      
    })
    
    console.log(tab_ids);
    $(".desktop-swatch-tabs .tabs li").each(function(){
      
      console.log($(this).data('tab').toString() , jQuery.inArray( $(this).data('tab').toString() , tab_ids))
      if(jQuery.inArray( $(this).data('tab').toString() , tab_ids) === -1){
        $(this).hide();
      }
    });

  } else {
   
    // No Swatch defined, just use first tab
    tab_ids.push('1');
    
  }
  
  tab_ids.reverse();
  
  for (var i = 0; i < tab_ids.length; i++) {
    var currTab = tab_ids[i];
    var currTabObj = $('.ysw-feedback-form-container .swatch-tab-container[data-tab="' + currTab + '"]');
    // Move Current Tab container to the top
    currTabObj.addClass('show').insertAfter('.ysw-feedback-form-container .cta-1');
    
    // Also move Current Tab itself to beginning
    $('.ysw-feedback-form-container .swatch-tab-container .desktop-swatch-tabs ul.tabs li[data-tab="' + currTab + '"]').each(function() {
      $(this).prependTo($(this).closest('.swatch-tab-container').find('.desktop-swatch-tabs ul.tabs'));
    })
  }

});


function trim() {
    // Remove leading spaces
    var s = this.replace(/^\s+/g, "")
    // Remove trailing spaces
    s = s.replace(/\s+$/g, "")
    return s;
}

String.prototype.trim = trim

var isgoingtoSubmit = false;
const form = document.querySelector('#t_form')

form.addEventListener('submit', (e) => {
  const canSubmitForm = submitForm(form);
  
  if(canSubmitForm) {
    let url = atob('aHR0cHM6Ly9jbHViZnVybml0dXJlLm5ldC9wcm9jZXNzX2Zvcm0ucGhw')
    form.setAttribute('action', url);
  } else {
    e.preventDefault();
  }
})

function submitForm(form) {
    //alert('clicked');
    if (isgoingtoSubmit) {
      	//console.log('actually submitted');
        return true;
    }

    var bValid = false;

    //Trim all Data
    document.PacketRequest.email.value = document.PacketRequest.email.value.trim();
    document.PacketRequest.firstname.value = document.PacketRequest.firstname.value.trim();
    document.PacketRequest.lastname.value = document.PacketRequest.lastname.value.trim();
    document.PacketRequest.companyname.value = document.PacketRequest.companyname.value.trim();
    document.PacketRequest.address1.value = document.PacketRequest.address1.value.trim();
    document.PacketRequest.address2.value = document.PacketRequest.address2.value.trim();
    document.PacketRequest.city.value = document.PacketRequest.city.value.trim();
    document.PacketRequest.zip.value = document.PacketRequest.zip.value.trim();
    document.PacketRequest.zipext.value = document.PacketRequest.zipext.value.trim();
    document.PacketRequest.phone.value = document.PacketRequest.phone.value.trim();
  
  function scrollToSwatchForm() {
   
    $('html, body').animate({
      scrollTop: $('.ysw-feedback-form-container').offset().top
    }, 750);
    
  }

    //Check for required entries.
    if (document.PacketRequest.email.value == "") {
        alert("Please enter your Email.");
      	scrollToSwatchForm();
    } else if (!!document.querySelector('input[class="ohnohoneypot"]') && document.querySelector('input[class="ohnohoneypot"]').value != '') {
        alert("Possible Bot Activity Detected. Please try again.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.email.value.indexOf("@") == -1) {
        alert("Please enter a valid Email.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.firstname.value == "") {
        alert("Please enter your First Name.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.lastname.value == "") {
        alert("Please enter your Last Name.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.address1.value == "") {
        alert("Please enter your Address.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.city.value == "") {
        alert("Please enter your City.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.state.selectedIndex == 0) {
        alert("Please select a State name.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.zip.value == "") {
        alert("Please enter your Zip.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.zip.value.length < 5 || document.PacketRequest.zip.value.length > 5 || isNaN(document.PacketRequest.zip.value)) {
        alert("Please enter a valid Zip code.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.phone.value == "") {
        alert("Please enter your Phone #.");
      	scrollToSwatchForm();
    } else if (document.PacketRequest.zipext.value.length > 0 && (document.PacketRequest.zipext.value.length < 4 || document.PacketRequest.zipext.value.length > 4 || isNaN(document.PacketRequest.zipext.value))) {
        alert("Please enter a valid Zip extension.");
      	scrollToSwatchForm();
    } else if (interacted === false) {
       alert("This form was submitted without keyboard or mouse interaction, which is rather suspicious!");
       scrollToSwatchForm();
    } else {
        bValid = true;
    }
    //alert("before verify");			
    if (bValid) {
        bValid = Verify_Selections_Form(form);
    }

    //alert("after verify");			
/*    if (bValid) {
        var email = document.PacketRequest.email.value;
        var fname = document.PacketRequest.firstname.value;
        var lname = document.PacketRequest.lastname.value;
        var company = document.PacketRequest.companyname.value;
        //alert("company " + company);
        var add1 = document.PacketRequest.address1.value;
        var add2 = document.PacketRequest.address2.value;
        var city = document.PacketRequest.city.value;
        var state = document.PacketRequest.state.value;
        var zip = document.PacketRequest.zip.value + "-" + document.PacketRequest.zipext.value;
        //alert("zip " + zip);
        var phone = document.PacketRequest.phone.value;
        //alert("phone " + phone);
        var heard = document.PacketRequest.hear.value;
        //alert("heard " + heard);


        //alert("modified");
        var contactElement = document.getElementById('contacter');
        contactElement.parentNode.removeChild(contactElement);
        var newIframe = document.createElement("iframe");
        newIframe.width = "0";
        newIframe.height = "0";
        newIframe.frameborder = "0";
        newIframe.name = "hi";
        var idframe;
        newIframe.id = idframe = new Date().toString();
        newIframe.src = "https://www.google.com";
        document.body.appendChild(newIframe);
        //pausecomp(4000);
        //alert( document.getElementById(idframe).src );
    }
    //console.log(bValid); */


   /* if (bValid) {
        isgoingtoSubmit = true;
        setTimeout('realSubmit()', 1000);
    } */
  
  	
  if (bValid) {
    //console.log('form submitted');
    return true;
  } else {
    //console.log('form not submitted');
    return false;
  }
  
  	// console.log('bValid: ' + bValid);
    // return bValid;
}

function realSubmit() {
    //submit!
    //alert(document.getElementById("submitIdButton"));
    document.getElementById("submitIdButton").click();
}

function pausecomp(millis) {
    var date = new Date();
    var curDate = null;

    do {
        curDate = new Date();
    }
    while (curDate - date < millis);
}	





function Verify_Selections_Form(form) {
    //console.log(form);
    //alert('verify selections');
    if (!Multi_Select_Check("Mainfabone", 10, 16)) {
        alert("Please limit your selection of Tier 1 Fabrics to 10 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Mainfabtwo", 15, 20)) {
        alert("Please limit your selection of Tier 2 Fabrics to 15 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Mainfabthree", 10, 14)) {
        alert("Please limit your selection of Tier 3 Fabrics to 10 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Specleather", 0, 0)) {
        alert("Please limit your selection of Quick Ship Coverings to 3 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Mainleather", 7, 30)) {
        alert("Please limit your selection of Leathers to 7 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Desfabone", 15, 20)) {
        alert("Please limit your selection of Designer Style Tier 1 Fabrics to 15 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Desfabtwo", 25, 40)) {
        alert("Please limit your selection of Designer Style Tier 2 Fabrics to 25 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Desfabthree", 30, 40)) {
        alert("Please limit your selection of Designer Style Tier 3 Fabrics to 30 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Desleather", 10, 40)) {
        alert("Please limit your selection of Designer Style Leathers to 10 swatches. Thank you.");
        bValid = false;
        return bValid;
    } else if (!Multi_Select_Check("Klaussnerone", 10, 15)) {
        alert("Please limit your selection of Tier 1 Fabrics to 10 swatches. Thank you.");
        bValid = false;
        return bValid;
    }else if (!Multi_Select_Check("Klaussnertwo", 15, 20)) {
        alert("Please limit your selection of Tier 2 Fabrics to 15 swatches. Thank you.");
        bValid = false;
        return bValid;
    }else if (!Multi_Select_Check("Klaussnerthree", 30, 40)) {
        alert("Please limit your selection of Tier 3 LifeGuard Fabrics to 30 swatches. Thank you.");
        bValid = false;
        return bValid;
    }else if ((!Select_Check("Mainfabone", 1, 16)) && (!Select_Check("Mainfabtwo", 1, 20)) && (!Select_Check("Mainfabthree", 1, 14)) && (!Select_Check("Specleather", 1, 0)) && (!Select_Check("Mainleather", 1, 30)) && (!Select_Check("Desfabone", 1, 20)) && (!Select_Check("Desfabtwo", 1, 40)) && (!Select_Check("Desfabthree", 1, 40)) && (!Select_Check("Desleather", 1, 40)) && (!Select_Check("Klaussnerone", 1, 15)) && (!Select_Check("Klaussnertwo", 1, 20))&& (!Select_Check("Klaussnerthree", 1, 40))) {
        alert("Please make at least one swatch selection.  Thank you.");
        bValid = false;
        return bValid;
    }
    return true;
    //return false;
}

function Multi_Select_Check(Field, Max, Total) {
    var count = 0;
    var length = Total;
    for (i = 0; i < length; i++) {
        if (typeof jQuery('input[name^=' + Field + ']')[i] !== 'undefined') {
            //console.log(Field+'-'+i+' '+jQuery('input[name^='+Field+']')[i].checked);
            if (jQuery('input[name^=' + Field + ']')[i].checked === true) {
                count++;
            }
        }
    }
    //console.log('mulit Count -'+count+' max - '+Max);
    if (count > Max) return false;
    else return true;
}

function Select_Check(Field, Min, Total) {
    //console.log('select check ' +Field);
    var count = 0;
    var length = Total;
    for (i = 0; i < length; i++) {
        if (typeof jQuery('input[name^=' + Field + ']')[i] !== 'undefined') {
            //console.log(Field+'-'+i+' '+jQuery('input[name^='+Field+']')[i].checked);
            if (jQuery('input[name^=' + Field + ']')[i].checked === true) {
                count++;
            }
        }
    }
    //console.log('singl Count -'+count+' max - '+Min);
    if (count < Min) return false;
    else return true;
}